export default __webpack_public_path__ + "static/software_1-284920f758e4750aab0e92b525aee70c.jpg";